// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://slqnufboyhkruqbttoxe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNscW51ZmJveWhrcnVxYnR0b3hlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ4Nzk4NjcsImV4cCI6MjA1MDQ1NTg2N30.jJUAu4HyYdj23GGVW1vNyi3qQkLZcLO5DUfZe-WZ6YU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);